module.exports = __webpack_public_path__ + "img/gebratenegarnelenmithintergrund.790a9975.jpg";